import { render, staticRenderFns } from "./WisdomStatsSelect.vue?vue&type=template&id=79c07fa3&"
import script from "./WisdomStatsSelect.vue?vue&type=script&lang=js&"
export * from "./WisdomStatsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports